import { WISHeadingsProps } from './types'

export const WISHeadings = ({ children, className }: WISHeadingsProps) => {
  return (
    <div className={className}>
      <h1 className='mb-3 font-medium uppercase text-lighthouseBlue'>
        Risk Management
      </h1>
      <h2 className='mb-8 text-3xl font-semibold'>{children}</h2>
    </div>
  )
}

export default WISHeadings
